module.exports = __webpack_public_path__ + "img/code.8999b398.jpg";